import script from "./danh-sach-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./danh-sach-menu.vue?vue&type=script&setup=true&lang=js"

import "./danh-sach-menu.vue?vue&type=style&index=0&id=4cf76398&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf76398"]])

export default __exports__